import { WSFilter, WSFilterOption } from "@wingspanhq/fe-component-library";
import { EngagementStatus } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { useQueryEngagementsListAll } from "../../../../../query/engagements/queries/useQueryEngagementsListAll";
import { usePayeeFilterOptions } from "../../../../Payees/hooks/usePayeeFilterOptions";

export function useBuildConfig() {
  const payeeOptions = usePayeeFilterOptions({
    filter: {
      "engagements.isWorkLoggingEnabled": true
    }
  });

  const queryEngagements = useQueryEngagementsListAll({
    filter: {
      status: EngagementStatus.Active,
      isDefault: false
    }
  });

  const engagementOptions = useMemo(
    (): WSFilterOption<"checkbox">[] =>
      (queryEngagements.data || [])
        .filter(e => e.workDefinitions && e.workDefinitions.length > 0)
        .map(e => ({
          name: e.engagementId,
          label: e.name
        })),
    [queryEngagements.data]
  );

  return useMemo((): WSFilter[] => {
    const config: WSFilter[] = [];

    config.push({
      title: "Contractor",
      name: "payeeId",
      type: "select",
      apiOptions: payeeOptions
    });

    config.push({
      title: "Engagement",
      name: "engagementId",
      type: "select",
      options: engagementOptions,
      searchable: true,
      loading: queryEngagements.isLoading
    });

    config.push({
      title: "Date range",
      name: "dateRange",
      type: "daterange",
      titleInLabel: true,
      options: ["all", "pastWeek", "pastMonth", "yearToDate", "custom"]
    });

    return config;
  }, [payeeOptions, engagementOptions, queryEngagements.isLoading]);
}
